import * as React from 'react';

export default class HandraiseIconInactive extends React.Component {
  render() {
    return React.createElement('svg', {
      className: this.props.className ? this.props.className : '',
      id: this.props.id ? this.props.id : '',
      width: '24px',
      height: '25px',
      dangerouslySetInnerHTML: {
        __html:
          '<path d="M17.4,4.5c-0.2,0-0.5,0-0.7,0.1V3.6c0-1.5-1.2-2.7-2.7-2.7c-0.4,0-0.8,0.1-1.1,0.2C12.5,0.5,11.7,0,10.8,0 C9.8,0,9,0.5,8.5,1.2C8.2,1.1,7.8,1,7.4,1C6,1,4.8,2.2,4.8,3.6v5C3.9,7.6,2.5,7.4,1.3,8c-1.3,0.7-1.7,2.1-1,3.5 c0.2,0.4,1.8,3.5,1.9,3.7c3.6,7.2,5.1,7.2,5.6,7.2h7.3c0.1,0,0.2,0,0.3-0.1c2.7-0.9,4.7-7.7,4.7-10.3V7.1 C20.1,5.7,18.9,4.5,17.4,4.5z M18.1,12c0,2.7-2,7.7-3.2,8.4h-7c-0.7-0.5-2.6-3.5-3.9-6.1c0,0,0,0,0,0c0-0.1-1.7-3.2-1.9-3.6 C1.8,10,2.2,9.8,2.3,9.8c0.3-0.2,0.8-0.1,1,0.2c0.2,0.4,1.6,2.7,1.6,2.7C5.1,13,5.6,13.2,6,13.1c0.4-0.1,0.7-0.5,0.8-0.9 c0-0.1,0-0.1,0-0.2v-0.4c0,0,0,0,0,0v-8C6.8,3.3,7.1,3,7.4,3s0.7,0.3,0.7,0.7v7c0,0.6,0.4,1,1,1s1-0.4,1-1V4.9c0,0,0-0.1,0-0.1V2.7 c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v8c0,0.6,0.4,1,1,1s1-0.4,1-1v-7c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7V11 c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1V7.1c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7V12z M16.6,24c0,0.6-0.4,1-1,1h-8 c-0.6,0-1-0.4-1-1s0.4-1,1-1h8C16.1,23,16.6,23.5,16.6,24z"/>',
      },
    });
  }
}
